<div class="solicitacoes-topo">
  <h1 class="solicitacoes-titulo">
    Minhas solicitações
    <span class="solicitacoes-enfeites" aria-hidden="true">
      <span class="solicitacoes-enfeite solicitacoes-enfeite-amarelo"></span>
      <span class="solicitacoes-enfeite solicitacoes-enfeite-triangulo"></span>
      <span class="solicitacoes-enfeite solicitacoes-enfeite-azul"></span>
    </span>
  </h1>
  <p class="solicitacoes-subtitulo">Acompanhe o status das suas solicitações de serviços e dos seus pedidos de acesso à informação.</p>
</div>

@if (falhaParcial(); as fonte) {
  <div class="solicitacoes-aviso solicitacoes-aviso-erro" role="alert">
    <span class="solicitacoes-aviso-icone" aria-hidden="true">
      <i-lucide name="circle-alert" size="18"></i-lucide>
    </span>

    <div class="solicitacoes-aviso-conteudo">
      <p class="solicitacoes-aviso-titulo">
        {{ fonte === 'sic' ? 'Não foi possível carregar os pedidos do e-SIC.' : 'Não foi possível carregar as solicitações de serviço.' }}
      </p>
      <button type="button" class="solicitacoes-botao solicitacoes-botao-limpar" (click)="tentarNovamenteFonte(fonte)">
        <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
        Tentar novamente
      </button>
    </div>
  </div>
}

@switch (estado()) {
  @case ('sessao') {
    <div class="solicitacoes-aviso" role="status">
      <span class="solicitacoes-aviso-icone" aria-hidden="true">
        <i-lucide name="log-in" size="18"></i-lucide>
      </span>

      <div>
        <p class="solicitacoes-aviso-titulo">Sua sessão foi encerrada.</p>
        <p class="solicitacoes-aviso-texto">
          Entre novamente para ver suas solicitações.
          <a class="solicitacoes-aviso-link" routerLink="/login">Entrar</a>
        </p>
      </div>
    </div>
  }

  @case ('carregando') {
    <p class="solicitacoes-carga" role="status" aria-live="polite">
      <i-lucide name="loader-circle" size="18" aria-hidden="true"></i-lucide>
      Carregando suas solicitações...
    </p>
  }

  @case ('falha') {
    <div class="solicitacoes-aviso solicitacoes-aviso-erro" role="alert">
      <span class="solicitacoes-aviso-icone" aria-hidden="true">
        <i-lucide name="circle-alert" size="18"></i-lucide>
      </span>

      <div class="solicitacoes-aviso-conteudo">
        <p class="solicitacoes-aviso-titulo">Não foi possível carregar suas solicitações.</p>
        <button type="button" class="solicitacoes-botao solicitacoes-botao-limpar" (click)="tentarNovamente()">
          <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
          Tentar novamente
        </button>
      </div>
    </div>
  }

  @case ('vazia') {
    <!-- Com uma fonte em falha, "você ainda não tem" seria afirmação falsa: só o aviso acima. -->
    @if (!falhaParcial()) {
      <div class="solicitacoes-vazio">
        <span class="solicitacoes-vazio-icone" aria-hidden="true">
          <i-lucide name="file-text" size="32"></i-lucide>
        </span>

        <p class="solicitacoes-vazio-texto">Você ainda não tem solicitações neste portal.</p>
      </div>
    }
  }

  @case ('pronto') {
    <section class="solicitacoes-filtros" aria-label="Filtrar solicitações">
      <div class="solicitacoes-filtros-grade">
        <div class="solicitacoes-campo">
          <label class="solicitacoes-rotulo" for="filtro-protocolo">Protocolo</label>
          <input
            id="filtro-protocolo"
            class="solicitacoes-input"
            type="text"
            autocomplete="off"
            placeholder="Digite o protocolo"
            [value]="rascunho().protocolo"
            (input)="aoDigitar('protocolo', $event)"
          />
        </div>

        <div class="solicitacoes-campo">
          <label class="solicitacoes-rotulo" for="filtro-servico">Serviço</label>
          <select
            id="filtro-servico"
            class="solicitacoes-input"
            [value]="rascunho().servico"
            (change)="aoDigitar('servico', $event)"
          >
            <option value="">Selecione...</option>
            @for (servico of servicos(); track servico) {
              <option [value]="servico" [selected]="servico === rascunho().servico">{{ servico }}</option>
            }
          </select>
        </div>

        <div class="solicitacoes-campo">
          <label class="solicitacoes-rotulo" for="filtro-status">Status</label>
          <select
            id="filtro-status"
            class="solicitacoes-input"
            [value]="rascunho().status"
            (change)="aoDigitar('status', $event)"
          >
            <option value="">Selecione...</option>
            @for (opcao of statusDisponiveis; track opcao.id) {
              <option [value]="opcao.id" [selected]="opcao.id === rascunho().status">{{ opcao.rotulo }}</option>
            }
          </select>
        </div>

        <div class="solicitacoes-campo">
          <label class="solicitacoes-rotulo" for="filtro-data-inicial">Data inicial</label>
          <input
            id="filtro-data-inicial"
            class="solicitacoes-input"
            type="date"
            [value]="rascunho().dataInicial"
            (change)="aoDigitar('dataInicial', $event)"
          />
        </div>

        <div class="solicitacoes-campo">
          <label class="solicitacoes-rotulo" for="filtro-data-final">Data final</label>
          <input
            id="filtro-data-final"
            class="solicitacoes-input"
            type="date"
            [value]="rascunho().dataFinal"
            (change)="aoDigitar('dataFinal', $event)"
          />
        </div>
      </div>

      <div class="solicitacoes-filtros-acoes">
        <button type="button" class="solicitacoes-botao solicitacoes-botao-filtrar" (click)="filtrar()">
          <i-lucide name="sliders-horizontal" size="16" aria-hidden="true"></i-lucide>
          Filtrar
        </button>

        <button
          type="button"
          class="solicitacoes-botao solicitacoes-botao-limpar"
          [disabled]="!temFiltroAtivo()"
          (click)="limparFiltros()"
        >
          <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
          Limpar filtros
        </button>
      </div>
    </section>

    <p class="solicitacoes-contagem" role="status">
      <i-lucide name="file-text" size="18" aria-hidden="true"></i-lucide>
      {{ total() }} {{ total() === 1 ? 'solicitação encontrada' : 'solicitações encontradas' }}
    </p>

    <div class="solicitacoes-cabecalho" aria-hidden="true">
      <span>Protocolo</span>
      <span>Descrição</span>
      <span>Status</span>
    </div>

    @if (solicitacoesDaPagina().length) {
      <ul class="solicitacoes-lista">
        @for (solicitacao of solicitacoesDaPagina(); track solicitacao.protocolo) {
          <li class="solicitacoes-item">
            <div class="solicitacoes-item-topo">
              <span class="solicitacoes-item-icone" aria-hidden="true">
                <i-lucide name="file-text" size="20"></i-lucide>
              </span>

              <span class="solicitacoes-item-identificacao">
                <strong class="solicitacoes-item-protocolo">Protocolo: {{ solicitacao.protocolo }}</strong>
                <span class="solicitacoes-item-abertura">
                  Aberto em {{ dataFormatada(solicitacao.abertaEm) }} às {{ solicitacao.abertaAs }}
                </span>
              </span>

              <span class="solicitacoes-status" [attr.data-status]="solicitacao.status">
                <i-lucide [name]="iconeStatus(solicitacao.status)" size="14" aria-hidden="true"></i-lucide>
                {{ rotuloItem(solicitacao) }}
              </span>

              <div class="solicitacoes-acoes">
                <button
                  type="button"
                  class="solicitacoes-item-menu"
                  [attr.aria-label]="'Ações da solicitação ' + solicitacao.protocolo"
                  [attr.aria-expanded]="menuAberto() === solicitacao.protocolo"
                  aria-haspopup="menu"
                  (click)="alternarMenu(solicitacao.protocolo, $event)"
                >
                  <i-lucide name="ellipsis-vertical" size="18" aria-hidden="true"></i-lucide>
                </button>

                @if (menuAberto() === solicitacao.protocolo) {
                  <div class="solicitacoes-menu" role="menu" (click)="$event.stopPropagation()">
                    <button type="button" class="solicitacoes-menu-item" role="menuitem" (click)="verDetalhes(solicitacao)">
                      <i-lucide name="eye" size="16" aria-hidden="true"></i-lucide>
                      Ver detalhes
                    </button>

                    <button
                      type="button"
                      class="solicitacoes-menu-item"
                      role="menuitem"
                      [disabled]="!solicitacao.respostas?.length"
                      (click)="verResposta(solicitacao)"
                    >
                      <i-lucide name="file-text" size="16" aria-hidden="true"></i-lucide>
                      Ver resposta
                    </button>

                    @if (solicitacao.podeContestar) {
                      <button type="button" class="solicitacoes-menu-item" role="menuitem" (click)="abrirContestacao(solicitacao)">
                        <i-lucide name="scale" size="16" aria-hidden="true"></i-lucide>
                        Contestar resposta
                      </button>
                    }

                    <button
                      type="button"
                      class="solicitacoes-menu-item solicitacoes-menu-item-perigo text-md-wrap text-nowrap"
                      role="menuitem"
                      [disabled]="!solicitacao.podeCancelar"
                      (click)="abrirCancelamento(solicitacao)"
                    >
                      <i-lucide name="circle-x" size="16" aria-hidden="true"></i-lucide>
                      Cancelar solicitação
                    </button>
                  </div>
                }
              </div>
            </div>

            <h2 class="solicitacoes-item-servico">{{ solicitacao.sic?.assunto ?? solicitacao.servico }}</h2>
            <p class="solicitacoes-item-descricao">{{ solicitacao.descricao }}</p>

            @if (solicitacao.sic) {
              <p class="solicitacoes-item-endereco">
                <i-lucide name="globe" size="16" aria-hidden="true"></i-lucide>
                {{ solicitacao.servico }}
              </p>
            } @else {
              <p class="solicitacoes-item-endereco">
                <i-lucide name="map-pin" size="16" aria-hidden="true"></i-lucide>
                {{ solicitacao.endereco }}
              </p>
            }
          </li>
        }
      </ul>

      <app-paginacao
        variante="simples"
        rotulo="Paginação das solicitações"
        [paginaAtual]="paginaAtual()"
        [totalPaginas]="totalPaginas()"
        [resumo]="'Exibindo ' + primeiroDaPagina() + ' a ' + ultimoDaPagina() + ' de ' + total() + ' solicitações'"
        (paginaMudou)="irParaPagina($event)"
      >
        <label class="solicitacoes-paginacao-tamanho">
          Itens por página:
          <select
            class="solicitacoes-input solicitacoes-input-compacto"
            [value]="itensPorPagina()"
            (change)="aoTrocarItensPorPagina($event)"
          >
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
          </select>
        </label>
      </app-paginacao>
    } @else {
      <div class="solicitacoes-vazio">
        <p class="solicitacoes-vazio-texto">Nenhuma solicitação encontrada para os filtros informados.</p>

        @if (temFiltroAtivo()) {
          <button type="button" class="solicitacoes-botao solicitacoes-botao-filtrar" (click)="limparFiltros()">
            Limpar filtros
          </button>
        }
      </div>
    }
  }
}

<dialog #modalDetalhes class="solicitacoes-modal" aria-labelledby="modal-detalhes-titulo" (close)="fecharModais()">
  @if (modalAberto() === 'detalhes' && selecionada(); as solicitacao) {
    <div class="solicitacoes-modal-conteudo">
      <div class="solicitacoes-modal-topo">
        <div>
          <h2 class="solicitacoes-modal-titulo" id="modal-detalhes-titulo">Detalhes da solicitação</h2>
          <p class="solicitacoes-modal-protocolo">Protocolo: {{ solicitacao.protocolo }}</p>
        </div>

        <button type="button" class="solicitacoes-modal-fechar" (click)="fecharModais()" aria-label="Fechar">
          <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
        </button>
      </div>

      <dl class="solicitacoes-modal-dados">
        <div class="solicitacoes-modal-dado">
          <dt>Tipo</dt>
          <dd>
            {{ solicitacao.tipo }}
            @if (solicitacao.segundaVia) {
              <span class="solicitacoes-via">Segunda via</span>
            }
          </dd>
        </div>
        <div class="solicitacoes-modal-dado">
          <dt>Status</dt>
          <dd>{{ rotuloItem(solicitacao) }}</dd>
        </div>
        <div class="solicitacoes-modal-dado">
          <dt>Abertura</dt>
          <dd>{{ dataFormatada(solicitacao.abertaEm) }} às {{ solicitacao.abertaAs }}</dd>
        </div>
        @if (solicitacao.prazo) {
          <div class="solicitacoes-modal-dado">
            <dt>Prazo</dt>
            <dd>{{ solicitacao.prazo }}</dd>
          </div>
        }
      </dl>

      <!-- Sempre presente enquanto o detalhe está aberto, para o leitor de tela anunciar o aviso. -->
      <div role="status" aria-live="polite">
        @if (avisoComplemento()) {
          <p class="solicitacoes-aviso-sucesso">
            <i-lucide name="circle-check" size="18" aria-hidden="true"></i-lucide>
            {{ avisoComplemento() }}
          </p>
        }
      </div>

      @if (solicitacao.pendencia; as pendencia) {
        <app-complemento-solicitacao
          [protocolo]="solicitacao.protocolo"
          [pendencia]="pendencia"
          (enviado)="aoEnviarComplemento(pendencia.pausaPrazo)"
        ></app-complemento-solicitacao>
      }

      @if (solicitacao.sic?.complemento; as complemento) {
        <app-complemento-pedido-sic
          [protocolo]="solicitacao.protocolo"
          [complemento]="complemento"
          (enviado)="aoEnviarComplementoSic()"
        ></app-complemento-pedido-sic>
      }

      <div class="solicitacoes-modal-secao">
        <p class="solicitacoes-modal-rotulo">Assunto</p>
        <p class="solicitacoes-modal-assunto">{{ solicitacao.sic?.assunto ?? solicitacao.servico }}</p>
      </div>

      @if (solicitacao.sic?.departamento; as departamento) {
        <div class="solicitacoes-modal-secao">
          <p class="solicitacoes-modal-rotulo">Categoria temática</p>
          <p class="solicitacoes-modal-texto">{{ departamento }}</p>
        </div>
      }

      <div class="solicitacoes-modal-secao">
        <p class="solicitacoes-modal-rotulo">Descrição</p>
        <p class="solicitacoes-modal-texto">{{ solicitacao.descricao }}</p>
      </div>

      @if (solicitacao.motivoCancelamento) {
        <div class="solicitacoes-modal-secao">
          <p class="solicitacoes-modal-rotulo">Motivo do cancelamento</p>
          <p class="solicitacoes-modal-texto">{{ solicitacao.motivoCancelamento }}</p>
        </div>
      }

      <div class="solicitacoes-modal-secao">
        <h3 class="solicitacoes-modal-subtitulo">Arquivos</h3>

        @if (solicitacao.arquivos.length) {
          <ul class="solicitacoes-arquivos">
            @for (arquivo of solicitacao.arquivos; track arquivo.id) {
              <li class="solicitacoes-arquivo">
                <i-lucide class="solicitacoes-arquivo-icone" name="file" size="18" aria-hidden="true"></i-lucide>

                <span class="solicitacoes-arquivo-texto">
                  <strong>{{ arquivo.nome }}</strong>
                  <span>{{ arquivo.data }} • {{ arquivo.tamanho }}</span>
                </span>

                <!-- O portal não baixa anexo do e-SIC: o contrato não traz endereço nem código. -->
                @if (!solicitacao.sic) {
                  <button
                    type="button"
                    class="solicitacoes-arquivo-baixar"
                    [disabled]="baixando() !== null"
                    [attr.aria-busy]="baixando() === 'cidadao-' + arquivo.codigo"
                    [attr.aria-label]="(baixando() === 'cidadao-' + arquivo.codigo ? 'Baixando ' : 'Baixar ') + arquivo.nome"
                    (click)="baixarArquivo(arquivo)"
                  >
                    {{ baixando() === 'cidadao-' + arquivo.codigo ? 'Baixando...' : 'Baixar' }}
                  </button>
                }

                @if (erroDownload()?.chave === 'cidadao-' + arquivo.codigo) {
                  <p class="solicitacoes-arquivo-erro" role="alert">{{ erroDownload()?.mensagem }}</p>
                }
              </li>
            }
          </ul>
        } @else {
          <p class="solicitacoes-modal-texto">Nenhum arquivo anexado a esta solicitação.</p>
        }
      </div>

      <div class="solicitacoes-modal-secao solicitacoes-modal-secao-separada">
        <h3 class="solicitacoes-modal-subtitulo">Histórico</h3>

        <ol class="solicitacoes-historico">
          @for (evento of solicitacao.historico; track evento.id) {
            <li class="solicitacoes-historico-item" [attr.data-tom]="evento.tom">
              <span class="solicitacoes-historico-marca" aria-hidden="true"></span>

              <span class="solicitacoes-historico-rotulo">{{ evento.rotulo }}</span>
              <p class="solicitacoes-historico-quando">{{ evento.quando }}</p>
              <p class="solicitacoes-historico-descricao">{{ evento.descricao }}</p>

              @if (evento.anexos?.length) {
                <ul class="solicitacoes-historico-anexos" aria-label="Arquivos enviados">
                  @for (anexo of evento.anexos; track $index) {
                    <li>
                      <i-lucide name="paperclip" size="14" aria-hidden="true"></i-lucide>
                      {{ anexo.nome }} ({{ anexo.tamanho }})
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ol>
      </div>

      <div class="solicitacoes-modal-acoes">
        <button type="button" class="solicitacoes-botao solicitacoes-botao-limpar" (click)="fecharModais()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>
      </div>
    </div>
  }
</dialog>

<dialog
  #modalResposta
  class="solicitacoes-modal solicitacoes-modal-resposta"
  aria-labelledby="modal-resposta-titulo"
  (close)="fecharModais()"
>
  @if (modalAberto() === 'resposta' && selecionada(); as solicitacao) {
    <div class="solicitacoes-resposta">
      <div class="solicitacoes-resposta-topo">
        <h2 class="solicitacoes-resposta-titulo" id="modal-resposta-titulo">{{ tituloResposta() }}</h2>

        @if (respostaMaisRecente()?.status && respostaMaisRecente(); as recente) {
          <span
            class="solicitacoes-resposta-selo"
            [class.solicitacoes-resposta-selo-pendente]="recente.status === 'Em análise'"
          >
            {{ recente.status }}
          </span>
        }

        <button type="button" class="solicitacoes-resposta-fechar" (click)="fecharModais()" aria-label="Fechar">
          <i-lucide name="x" size="22" aria-hidden="true"></i-lucide>
        </button>
      </div>

      <dl class="solicitacoes-resposta-resumo">
        <div>
          <dt>Protocolo</dt>
          <dd>#{{ solicitacao.protocolo }}</dd>
        </div>
        <div>
          <dt>Assunto</dt>
          <dd>{{ solicitacao.sic?.assunto ?? solicitacao.servico }}</dd>
        </div>
        <div class="solicitacoes-resposta-resumo-fim">
          <dt>Respondido em</dt>
          <dd>{{ respostaMaisRecente()?.respondidaEm ?? '—' }}</dd>
        </div>
      </dl>

      <div class="solicitacoes-resposta-corpo">
        @for (resposta of respostasExibidas(); track $index; let indice = $index) {
          <article class="solicitacoes-resposta-item" [attr.aria-labelledby]="'resposta-titulo-' + indice">
            <h3 class="solicitacoes-resposta-subtitulo" [id]="'resposta-titulo-' + indice">
              Resposta de {{ resposta.respondidaEm }}
              @if (resposta.status) {
                <span class="solicitacoes-resposta-status">{{ resposta.status }}</span>
              }
            </h3>

            @if (resposta.tipo) {
              <p class="solicitacoes-resposta-paragrafo">
                <strong>Tipo de resposta:</strong> {{ resposta.tipo }}
                @if (resposta.fundamento) {
                  <br><strong>Fundamento legal:</strong> {{ resposta.fundamento }}
                }
              </p>
            }

            @for (paragrafo of resposta.paragrafos; track $index) {
              <p class="solicitacoes-resposta-paragrafo">{{ paragrafo }}</p>
            }

            @if (resposta.formularios?.length) {
              <h4 class="solicitacoes-resposta-rotulo">Formulários indicados</h4>
              <ul class="solicitacoes-resposta-lista">
                @for (formulario of resposta.formularios; track $index) {
                  <li>{{ formulario }}</li>
                }
              </ul>
            }

            @if (resposta.links?.length) {
              <h4 class="solicitacoes-resposta-rotulo">Links</h4>
              <ul class="solicitacoes-resposta-lista">
                @for (link of resposta.links; track $index) {
                  <li>
                    <a class="solicitacoes-resposta-link" [href]="link" target="_blank" rel="noopener noreferrer">
                      {{ link }}
                      <i-lucide name="external-link" size="14" aria-hidden="true"></i-lucide>
                      <span class="visually-hidden">(abre em nova aba)</span>
                    </a>
                  </li>
                }
              </ul>
            }

            @if (resposta.anexos?.length) {
              <h4 class="solicitacoes-resposta-rotulo">Anexos</h4>
              <ul class="solicitacoes-arquivos">
                @for (anexo of resposta.anexos; track anexo.codigo) {
                  <li class="solicitacoes-arquivo">
                    <i-lucide class="solicitacoes-arquivo-icone" name="file" size="18" aria-hidden="true"></i-lucide>

                    <span class="solicitacoes-arquivo-texto">
                      <strong>{{ anexo.nome }}</strong>
                      <span>{{ anexo.tamanho }}</span>
                    </span>

                    <button
                      type="button"
                      class="solicitacoes-arquivo-baixar"
                      [disabled]="baixando() !== null"
                      [attr.aria-busy]="baixando() === 'resposta-' + anexo.codigo"
                      [attr.aria-label]="(baixando() === 'resposta-' + anexo.codigo ? 'Baixando ' : 'Baixar ') + anexo.nome"
                      (click)="baixarAnexoResposta(anexo)"
                    >
                      {{ baixando() === 'resposta-' + anexo.codigo ? 'Baixando...' : 'Baixar' }}
                    </button>

                    @if (erroDownload()?.chave === 'resposta-' + anexo.codigo) {
                      <p class="solicitacoes-arquivo-erro" role="alert">{{ erroDownload()?.mensagem }}</p>
                    }
                  </li>
                }
              </ul>
            }
          </article>
        }
      </div>

      <div class="solicitacoes-resposta-acoes">
        <button type="button" class="solicitacoes-resposta-voltar" (click)="fecharModais()">
          <i-lucide name="arrow-left" size="18" aria-hidden="true"></i-lucide>
          Voltar
        </button>
      </div>
    </div>
  }
</dialog>

<dialog
  #modalCancelamento
  class="solicitacoes-modal solicitacoes-modal-aviso"
  aria-labelledby="modal-cancelamento-titulo"
  (close)="fecharModais()"
>
  @if (modalAberto() === 'cancelamento' && selecionada(); as solicitacao) {
    <form class="solicitacoes-cancelar" (submit)="confirmarCancelamento($event)">
      <div class="solicitacoes-cancelar-corpo">
        <span class="solicitacoes-cancelar-icone" aria-hidden="true">!</span>

        <h2 class="solicitacoes-cancelar-titulo" id="modal-cancelamento-titulo">Cancelar solicitação</h2>

        <p class="solicitacoes-cancelar-texto">
          Tem certeza que deseja cancelar esta solicitação? Esta ação não poderá ser desfeita e o protocolo
          #{{ solicitacao.protocolo }} será encerrado definitivamente.
        </p>

        <div class="solicitacoes-cancelar-campo">
          <label class="solicitacoes-cancelar-rotulo" for="motivo-cancelamento">Motivo do cancelamento</label>
          <textarea
            id="motivo-cancelamento"
            class="solicitacoes-cancelar-textarea"
            rows="4"
            maxlength="500"
            required
            placeholder="Descreva o motivo do cancelamento..."
            aria-describedby="motivo-cancelamento-ajuda motivo-cancelamento-erro"
            [value]="motivoCancelamento()"
            [disabled]="cancelando()"
            (input)="aoDigitarMotivo($event)"
          ></textarea>

          <div id="motivo-cancelamento-ajuda">
            @if (!motivoCancelamento().trim()) {
              <p class="solicitacoes-obrigatorio">O motivo é obrigatório para confirmar o cancelamento.</p>
            }
          </div>
        </div>

        <div id="motivo-cancelamento-erro" role="alert">
          @if (erroCancelamento(); as erro) {
            <div class="solicitacoes-cancelar-erro">
              <p>{{ erro.mensagem }}</p>

              @if (erro.detalhes.length) {
                <ul>
                  @for (detalhe of erro.detalhes; track $index) {
                    <li>{{ detalhe }}</li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>

      <div class="solicitacoes-cancelar-acoes">
        <button type="button" class="solicitacoes-cancelar-voltar" [disabled]="cancelando()" (click)="fecharModais()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>

        <button
          type="submit"
          class="solicitacoes-cancelar-confirmar"
          [disabled]="!motivoCancelamento().trim() || cancelando()"
          [attr.aria-busy]="cancelando()"
        >
          <i-lucide name="check" size="16" aria-hidden="true"></i-lucide>
          {{ cancelando() ? 'Cancelando...' : 'Confirmar Cancelamento' }}
        </button>
      </div>
    </form>
  }
</dialog>

<dialog
  #modalContestacao
  class="solicitacoes-modal solicitacoes-modal-aviso solicitacoes-modal-contestacao"
  aria-labelledby="modal-contestacao-titulo"
  aria-describedby="modal-contestacao-instrucao"
  (close)="fecharModais()"
>
  @if (modalAberto() === 'contestacao' && selecionada(); as solicitacao) {
    <form class="solicitacoes-cancelar" novalidate (submit)="confirmarContestacao($event)">
      <div class="solicitacoes-cancelar-corpo solicitacoes-contestar-corpo">
        <h2 class="solicitacoes-cancelar-titulo" id="modal-contestacao-titulo">Pedido de Contestação de Resposta</h2>

        <p class="solicitacoes-cancelar-texto" id="modal-contestacao-instrucao">
          Classifique o motivo da contestação e, se desejar, adicione uma justificativa para análise.
        </p>

        <p class="solicitacoes-modal-protocolo">Protocolo: #{{ solicitacao.protocolo }}</p>

        <fieldset
          class="solicitacoes-contestar-grupo"
          [attr.aria-describedby]="erroMotivoContestacao() ? 'contestacao-motivo-erro' : null"
          [attr.aria-invalid]="erroMotivoContestacao() ? 'true' : null"
        >
          <legend class="solicitacoes-cancelar-rotulo">
            Motivo da reprova <span class="solicitacoes-obrigatorio-marca" aria-hidden="true">*</span>
          </legend>

          @for (opcao of motivosContestacao; track opcao.chave) {
            <label class="solicitacoes-contestar-opcao">
              <input
                type="radio"
                name="motivo-contestacao"
                [value]="opcao.chave"
                [checked]="contestacao().motivo === opcao.chave"
                [disabled]="contestando()"
                (change)="aoEscolherMotivo(opcao.chave)"
              />
              {{ opcao.rotulo }}
            </label>
          }

          @if (erroMotivoContestacao()) {
            <p class="solicitacoes-obrigatorio" id="contestacao-motivo-erro">{{ erroMotivoContestacao() }}</p>
          }
        </fieldset>

        @if (contestacao().motivo === 'Outros') {
          <div class="solicitacoes-cancelar-campo">
            <label class="solicitacoes-cancelar-rotulo" for="contestacao-motivo-outro">
              Especifique o motivo <span class="solicitacoes-obrigatorio-marca" aria-hidden="true">*</span>
            </label>
            <input
              id="contestacao-motivo-outro"
              class="solicitacoes-input"
              type="text"
              autocomplete="off"
              [attr.maxlength]="limiteMotivoOutro"
              [attr.aria-invalid]="erroMotivoOutro() ? 'true' : null"
              [attr.aria-describedby]="erroMotivoOutro() ? 'contestacao-motivo-outro-erro' : null"
              [value]="contestacao().motivoOutro"
              [disabled]="contestando()"
              (input)="aoDigitarContestacao('motivoOutro', $event)"
            />
            @if (erroMotivoOutro()) {
              <p class="solicitacoes-obrigatorio" id="contestacao-motivo-outro-erro">{{ erroMotivoOutro() }}</p>
            }
          </div>
        }

        <div class="solicitacoes-cancelar-campo">
          <label class="solicitacoes-cancelar-rotulo" for="contestacao-justificativa">
            Justificativa
            @if (exigeJustificativa()) {
              <span class="solicitacoes-obrigatorio-marca" aria-hidden="true">*</span>
              <span class="visually-hidden">(obrigatória)</span>
            } @else {
              <span class="solicitacoes-opcional">(opcional)</span>
            }
          </label>
          <textarea
            id="contestacao-justificativa"
            class="solicitacoes-cancelar-textarea"
            rows="5"
            placeholder="Explique por que a resposta não atende ao seu pedido..."
            [attr.maxlength]="limiteJustificativa"
            [attr.required]="exigeJustificativa() ? '' : null"
            [attr.aria-invalid]="erroJustificativa() ? 'true' : null"
            [attr.aria-describedby]="'contestacao-justificativa-contador' + (erroJustificativa() ? ' contestacao-justificativa-erro' : '')"
            [value]="contestacao().justificativa"
            [disabled]="contestando()"
            (input)="aoDigitarContestacao('justificativa', $event)"
          ></textarea>
          <p class="solicitacoes-contestar-contador" id="contestacao-justificativa-contador">
            {{ contestacao().justificativa.length }}/{{ limiteJustificativa }}
          </p>
          @if (erroJustificativa()) {
            <p class="solicitacoes-obrigatorio" id="contestacao-justificativa-erro">{{ erroJustificativa() }}</p>
          }
        </div>

        <div role="alert">
          @if (erroContestacao(); as erro) {
            <div class="solicitacoes-cancelar-erro">
              <p>{{ erro.mensagem }}</p>

              @if (erro.detalhes.length) {
                <ul>
                  @for (detalhe of erro.detalhes; track $index) {
                    <li>{{ detalhe }}</li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>

      <div class="solicitacoes-cancelar-acoes">
        <button type="button" class="solicitacoes-cancelar-voltar" [disabled]="contestando()" (click)="fecharModais()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>

        <button
          type="submit"
          class="solicitacoes-cancelar-confirmar solicitacoes-contestar-enviar"
          [disabled]="contestando()"
          [attr.aria-busy]="contestando()"
        >
          <i-lucide name="send" size="16" aria-hidden="true"></i-lucide>
          {{ contestando() ? 'Enviando...' : 'Enviar Contestação' }}
        </button>
      </div>
    </form>
  }
</dialog>
